import { useQuery } from '@tanstack/react-query'
import { getStudentAwardPreview } from '../requests'

type UseGetStudentAwardPreviewParams = {
  programId: number
  studentIds: number[]
  programPurseIds: number[]
  enabled: boolean
}

export function useGetStudentAwardPreview({
  programId,
  studentIds,
  programPurseIds,
  enabled,
}: UseGetStudentAwardPreviewParams) {
  return useQuery({
    queryKey: ['student-award-preview', programId, studentIds, programPurseIds],
    queryFn: () =>
      getStudentAwardPreview({
        programId,
        studentIds,
        programPurseIds,
      }),
    enabled: enabled,
    staleTime: 0,
  })
}
